import zsmLayout from '@/zsm-layout'
const shopRouter = {
  path: '/weixin',
  component: zsmLayout,
  name: 'weixin',
  hidden: true,
  redirect: '/weixin/article',
  children: [
    {
      path: '/weixin',
      component: () => import('@/view/weixin/index'),
      name: 'weixin',
      children:[
        {
        path: '/weixin/article',
        component: () => import('@/view/weixin/article'),
         name: 'weixin'
          }
      ]
    }
  ]
}

export default shopRouter
